import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Col } from 'react-bootstrap';
import { getYearOptions } from '../../services/dateServices';
import Api from '../../../../Global/Modules/Api'

class BekendeCursusNew extends Component {

    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this)
        this.renderDiploma = this.renderDiploma.bind(this)
        this.state = {
            date: ''
        }
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        Api.print(`${name}: ${value}`)
        Api.print(this.state)
        this.setState({ [name]: value })
        this.props.onUpdate(name, value)
    }

    renderDiploma() {
        let diploma = this.props.diploma

        if (diploma)
            return <FormGroup controlId="BekendeCursusAfgerond">
                <Col componentClass={ControlLabel} sm={4}>
                    Certificaat (verplicht)
                </Col>
                <Col sm={6}>
                    <FormControl type="File" required inputRef={input => {
                        this.props.onFileUpdate(input)
                    }} />
                </Col>
            </FormGroup>

        else
            return diploma !== null ? <FormGroup controlId="BekendeCursusAfgerond">
                <Col componentClass={ControlLabel} sm={4}>
                    Certificaat
                </Col>
                <Col sm={6}>
                    <FormControl type="File" inputRef={input => this.props.onFileUpdate(input)} />
                </Col>
            </FormGroup> : null
    }

    render() {
        return (
            <div>
                <FormGroup controlId="BekendeOpleidingAfgerond">
                    <Col componentClass={ControlLabel} sm={4}>
                        Afgerond in
                    </Col>
                    <Col sm={6}>
                        <FormControl componentClass="select" name="date" value={this.state.date} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup controlId="BekendeOpleidingPunten">
                    <Col componentClass={ControlLabel} sm={4}>
                        Punten
                    </Col>
                    <Col sm={6}>
                        <FormControl.Static>
                            <i><small>{this.props.points ? this.props.points : 'aantal punten wordt berekend aan de hand van de input *'}</small></i>
                        </FormControl.Static>
                    </Col>
                </FormGroup>
                {this.renderDiploma()}
            </div>
        );
    }
}

export default BekendeCursusNew;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/Toevoegen/BekendeCursusNew.js